var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15V13.5M4.00005 15V7C4.00005 5.114 4.00005 4.172 4.58605 3.586C5.17205 3 6.11405 3 8.00005 3H11M18 9.714V11M18 9.714C17.4565 9.71781 16.9201 9.58968 16.4369 9.34061C15.9538 9.09154 15.5383 8.72897 15.226 8.284M18 9.714C18.5436 9.71781 19.08 9.58868 19.5631 9.33961C20.0463 9.09054 20.4618 8.72797 20.774 8.283M18 3.285C19.157 3.285 20.176 3.853 20.774 4.715M15.226 4.717C15.5383 4.27203 15.9538 3.90946 16.4369 3.66039C16.9201 3.41132 17.4565 3.28319 18 3.287V2M15.226 4.717L14 3.93M15.226 4.717C14.8617 5.24019 14.6664 5.86144 14.6664 6.499C14.6664 7.13656 14.8617 7.75881 15.226 8.282L14 9.07M22 3.929L20.774 4.717C21.1384 5.24019 21.3337 5.86144 21.3337 6.499C21.3337 7.13656 21.1384 7.75881 20.774 8.282L22 9.07M3.49805 16.015L4.02005 15H19.952L20.502 16.015C21.945 18.677 22.305 20.008 21.756 21.004C21.207 22 19.754 22 16.846 22H7.15405C4.24505 22 2.79105 22 2.24305 21.004C1.69405 20.008 2.05405 18.677 3.49805 16.015Z",
    stroke: "#8F95B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationIcon);
export default __webpack_public_path__ + "static/media/application-icon.865cbff393cbf793df71f64cbdf22f73.svg";
export { ForwardRef as ReactComponent };